(function () {
  const root = document.querySelector("[data-zeus-lex-root]");
  if (!root) return;

  const input = root.querySelector("[data-zeus-lex-search]");
  const cards = root.querySelectorAll("[data-zeus-lex-card]");
  const empty = root.querySelector("[data-zeus-lex-no-results]");

  if (!input || !cards.length) return;

  function normalize(value) {
    return (value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function filter() {
    const q = normalize(input.value.trim());
    let visible = 0;

    cards.forEach((card) => {
      const hay = normalize(card.getAttribute("data-search"));
      const show = !q || hay.includes(q);
      card.classList.toggle("is-hidden", !show);
      if (show) visible += 1;
    });

    if (empty) {
      empty.hidden = !q || visible > 0;
    }
  }

  input.addEventListener("input", filter);
})();
